import { render, staticRenderFns } from "./school-form.vue?vue&type=template&id=0db4ae9a&scoped=true&"
import script from "./school-form.vue?vue&type=script&lang=js&"
export * from "./school-form.vue?vue&type=script&lang=js&"
import style0 from "./school-form.vue?vue&type=style&index=0&id=0db4ae9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db4ae9a",
  null
  
)

export default component.exports